import React, { useState, useEffect, useRef } from "react";

const LibraryBookFinder = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const containerRef = useRef(null);
  const spaceRef = useRef(null);
  const isInitializedRef = useRef(false);

  const API_ENDPOINT =
    "https://lnudevices-dot-optimus-lnu.df.r.appspot.com/map-3";
  const CLIENT_ID = "pub_49a6761085174cd0b3e9875578e036c2";

  // Floor configurations
  const floorConfigs = {
    "1f": {
      spaceId: "73242c82-a0e9-4c96-8d28-089829ecf3d0",
      bookShelves: [
        {
          "id": "f2620ecb-34f0-4399-bb26-e9cd2ed764c8",
          "name": "1A05",
          "furnitureId": "fa84a8c5-70e6-4ab5-86a0-95c19b643aeb",
          "layerType": "furniture"
        },
        {
          "id": "a6f0b1b5-e3cc-4c12-a047-7cceb05750fd",
          "name": "1A04",
          "furnitureId": "79563d85-798e-4201-bff1-037ecdd6c2c8",
          "layerType": "furniture"
        },
        {
          "id": "2375da06-e8b5-410d-8188-55ed1556b8dd",
          "name": "1A03",
          "furnitureId": "3f336535-1e3d-4701-ab75-2d5fc2cf729c",
          "layerType": "furniture"
        },
        {
          "id": "843aec26-77c3-4de0-a869-48865aecf6ec",
          "name": "1A02",
          "furnitureId": "6627a9ef-53b9-4898-b7dc-c48b99dfafd7",
          "layerType": "furniture"
        },
        {
          "id": "dddda165-0612-4665-a1cf-983c238dbd69",
          "name": "1A01",
          "furnitureId": "61bbaf68-7a53-4dc3-a774-ddd0ea208559",
          "layerType": "furniture"
        },
        {
          "id": "f8061605-1899-4df2-96d1-9fbb0070b8bd",
          "name": "1A06",
          "furnitureId": "1f9c78b3-e3cb-41a0-b086-4a3a4b652df7",
          "layerType": "furniture"
        },
        {
          "id": "5864b741-4392-4673-8ca2-c665f99b18fd",
          "name": "1A07",
          "furnitureId": "9d7291ad-68ad-42e4-89fe-4e519e00ca6e",
          "layerType": "furniture"
        },
        {
          "id": "5c42d80c-a4a9-44f6-ae71-732f00284ba6",
          "name": "1A08",
          "furnitureId": "84ebd0c9-ba81-4fc7-a67d-61039db89252",
          "layerType": "furniture"
        },
        {
          "id": "8e8c1ffd-679b-47c7-95ad-4d4d9b227064",
          "name": "1A09",
          "furnitureId": "c002f402-ea33-4ece-b9e7-b5e5dfdc6ebf",
          "layerType": "furniture"
        },
        {
          "id": "c50f9875-682a-4766-ac60-b005d34e1443",
          "name": "1A10",
          "furnitureId": "42af5dfb-edcf-418c-9710-de7abe5985e3",
          "layerType": "furniture"
        },
        {
          "id": "af4c0096-2bfa-4cf6-ba54-0dea89ff56b4",
          "name": "1A11",
          "furnitureId": "ac8a2596-d9cd-4bee-913f-b6f3334e69bb",
          "layerType": "furniture"
        },
        {
          "id": "95a022c8-fb3a-4838-9b3a-3098e0f9c9b9",
          "name": "1A12",
          "furnitureId": "40822d8b-5fa5-4a21-800f-e7d8ffa62877",
          "layerType": "furniture"
        },
        {
          "id": "81297a59-ea56-44de-bff7-7df87c5a0afe",
          "name": "1A13",
          "furnitureId": "7e56f532-bea1-49b3-a683-3faa8fb91b15",
          "layerType": "furniture"
        },
        {
          "id": "53348ea9-26a1-48b6-9f79-4ce6ef819052",
          "name": "1A14",
          "furnitureId": "317c32df-9186-4ec3-ade5-4308882f77a6",
          "layerType": "furniture"
        },
        {
          "id": "cfba7d5f-b2fd-4022-9932-9bf6872c7084",
          "name": "1A15",
          "furnitureId": "e373386f-170d-4a81-919f-052f7396f216",
          "layerType": "furniture"
        },
        {
          "id": "2ed570db-ae70-4003-824a-c430042dbeee",
          "name": "1A16",
          "furnitureId": "87ece811-7cb4-4210-ac60-1f1211a8a5cf",
          "layerType": "furniture"
        },
        {
          "id": "4d96fd30-1797-4b09-a85d-52e3e2bff8f4",
          "name": "1A17",
          "furnitureId": "71e0494f-8390-4efb-a176-ed655ea33c42",
          "layerType": "furniture"
        },
        {
          "id": "256b9ca9-a470-425f-b0c9-85b8f79e1062",
          "name": "1A18",
          "furnitureId": "6e3da7b5-fcb0-47e7-9307-58e0c869fc4e",
          "layerType": "furniture"
        },
        {
          "id": "9a4cc330-99bc-4b26-a67e-bf0b3b42e529",
          "name": "1A19",
          "furnitureId": "f7e92a58-efbf-4b67-9f5a-f7d429f47fc1",
          "layerType": "furniture"
        },
        {
          "id": "d0c20e00-9e52-4cf6-a83a-d72358ca1ace",
          "name": "1A20",
          "furnitureId": "b3b2bbe5-b97b-41e0-9429-231b4c28283a",
          "layerType": "furniture"
        },
        {
          "id": "9f5076e1-7abb-4334-9236-760316189e51",
          "name": "1A21",
          "furnitureId": "4b06e0bb-54d0-4bd2-89c7-b49268e5bb83",
          "layerType": "furniture"
        },
        {
          "id": "e35af0be-a17e-40b5-9ec7-8ce80e8a2ce2",
          "name": "1A22",
          "furnitureId": "b23e1ac3-0cd0-47d9-9812-af67c7a438d7",
          "layerType": "furniture"
        },
        {
          "id": "ce1d63db-29c4-4909-974f-9424d519a59a",
          "name": "1A23",
          "furnitureId": "85f6eb42-a174-482c-9b9e-a814379eb6b6",
          "layerType": "furniture"
        },
        {
          "id": "f5d3973b-47b8-455d-9d81-327ec6da63d1",
          "name": "1A24",
          "furnitureId": "2bf31adc-db58-4663-9bf3-8377daffa4d9",
          "layerType": "furniture"
        },
        {
          "id": "0a17ceda-ff10-42dc-a46b-2d2925c22cdb",
          "name": "1A25",
          "furnitureId": "b4d7bac1-9ea3-4e9a-a5c4-29833fa1ef7c",
          "layerType": "furniture"
        },
        {
          "id": "d72a1d4c-d603-440f-8d2d-10bf9060fe3b",
          "name": "1A26",
          "furnitureId": "a8d3445a-837d-47ee-ad20-90ca1529d972",
          "layerType": "furniture"
        },
        {
          "id": "eebe6a5e-dfc7-4492-8fb0-39a0b405addf",
          "name": "1A27",
          "furnitureId": "e8779d82-f11a-489e-84ee-d510f642642a",
          "layerType": "furniture"
        },
        {
          "id": "d73c99b7-b43b-43d7-a6ca-2f1c50fd8e8d",
          "name": "1A28",
          "furnitureId": "488bb88f-0894-437a-9dca-12a92d33ec98",
          "layerType": "furniture"
        },
        {
          "id": "f91ed584-35ea-44c1-a129-d49914e8f21c",
          "name": "1A29",
          "furnitureId": "9ed8575b-e163-40f6-803c-b68231d30c20",
          "layerType": "furniture"
        },
        {
          "id": "030893c7-e7f5-4a30-a5b4-23db8233afe2",
          "name": "1A30",
          "furnitureId": "36a9891f-367a-4e6c-ac6d-ae45f0e85ddb",
          "layerType": "furniture"
        },
        {
          "id": "0924d73e-16a1-4aaa-b1a4-b864b99c464c",
          "name": "1B01-1",
          "furnitureId": "076b262f-2a84-4289-a691-3201bdf8458d",
          "layerType": "furniture"
        },
        {
          "id": "1b293437-6732-4c59-a01a-9c956371f72d",
          "name": "1B01-2",
          "furnitureId": "e3f87e45-aeca-4931-8ecf-42203a35ad90",
          "layerType": "furniture"
        },
        {
          "id": "a91c0693-2372-4188-aae4-170f8f0ec7de",
          "name": "1B01-3",
          "furnitureId": "19f4c425-6bdb-48f1-81be-18d8a9614f7a",
          "layerType": "furniture"
        },
        {
          "id": "9321d7da-8dff-482e-880a-b41dd0a3012b",
          "name": "1B01-4",
          "furnitureId": "24847b3e-2d17-430d-977a-cfccf5e4a129",
          "layerType": "furniture"
        },
        {
          "id": "eebfe393-227a-46a1-bc64-36b006845cc8",
          "name": "1B01-5",
          "furnitureId": "abfadaf3-e0a9-4fdd-8acf-66fc3d784f4a",
          "layerType": "furniture"
        },
        {
          "id": "4534d0ad-264f-4c65-b188-0bccfd1457d0",
          "name": "1B01-6",
          "furnitureId": "8bcea004-56e9-4cf3-a99f-26d01bd098df",
          "layerType": "furniture"
        },
        {
          "id": "e8be8147-482e-4213-8bef-8fb861f9cc62",
          "name": "1B02",
          "furnitureId": "b3a46ae0-5bcf-419d-949f-324db29dae44",
          "layerType": "furniture"
        },
        {
          "id": "15be1531-f8d5-4fd9-9fe0-8b0d40a437be",
          "name": "1B03-1",
          "furnitureId": "6eefa067-3876-4430-89f4-6c9fe0b44f1d",
          "layerType": "furniture"
        },
        {
          "id": "094267e6-0121-4493-9772-a5311852004e",
          "name": "1B03-2",
          "furnitureId": "e2177516-6ce3-48b5-be9c-893e3806d29d",
          "layerType": "furniture"
        },
        {
          "id": "d89c1fbf-c7d9-4e95-a527-a8bd0565d5bd",
          "name": "1B03-3",
          "furnitureId": "ce1bc860-7815-4c1f-be7e-4b0b24cbe4c7",
          "layerType": "furniture"
        },
        {
          "id": "3c450a33-98fd-4b32-b959-f4e771409081",
          "name": "1B03-4",
          "furnitureId": "193b4e0e-b82b-41e4-81a7-771d5bb3f635",
          "layerType": "furniture"
        },
        {
          "id": "125321bc-2b41-4f0d-b7fc-2c54e7b804c9",
          "name": "1B03-5",
          "furnitureId": "13aef216-755b-48e9-84c7-99c9912f96fa",
          "layerType": "furniture"
        },
        {
          "id": "f55f8839-8d65-4cb6-a9fb-792aee6f9cdf",
          "name": "1B03-6",
          "furnitureId": "705f3f36-2641-4ec8-95b9-b4c50ef52c92",
          "layerType": "furniture"
        },
        {
          "id": "03cc3cad-3287-4ba7-9ae8-17e070463104",
          "name": "1B03-7",
          "furnitureId": "3abd463b-aae0-40d6-a4b8-5f222e26eb96",
          "layerType": "furniture"
        },
        {
          "id": "18af97ea-e1eb-4ad1-a428-e43f27a15d21",
          "name": "1B04",
          "furnitureId": "6a1b367f-294a-4f11-8460-8212be538f76",
          "layerType": "furniture"
        },
        {
          "id": "9fa1c54d-9d65-4ce8-bc90-713a465f3b80",
          "name": "1B05",
          "furnitureId": "dab5939a-b323-46ca-ae79-c6db64738947",
          "layerType": "furniture"
        },
        {
          "id": "3ed1de6f-bfd1-419e-bbbc-80760fe155af",
          "name": "1C01",
          "furnitureId": "043102d7-716c-42df-96e1-d77cb0980adf",
          "layerType": "furniture"
        },
        {
          "id": "37a3a7ad-466b-4d19-bbf1-8cae3c0ec8d2",
          "name": "1C02",
          "furnitureId": "c10d391c-c52e-4b3e-b07c-4e251585c7b0",
          "layerType": "furniture"
        },
        {
          "id": "f6ad21e6-76c9-4fe6-be52-b2a5d0f9ebe4",
          "name": "1C03",
          "furnitureId": "31c73ca7-1285-44e5-b64e-f3a316e52336",
          "layerType": "furniture"
        },
        {
          "id": "9ea19d91-bd30-457c-844e-2a494494447d",
          "name": "1C04",
          "furnitureId": "2361d874-ba80-4f5c-b664-50cf215ddc76",
          "layerType": "furniture"
        },
        {
          "id": "7e7c5e80-950c-4b3e-9515-9ecb18eb8c0b",
          "name": "1C05",
          "furnitureId": "8be85130-6bad-40a2-b663-10831d3bbd41",
          "layerType": "furniture"
        },
        {
          "id": "f47f988d-7444-420f-b19a-027544db6ec1",
          "name": "1C06",
          "furnitureId": "5722c50e-aa91-4863-98e9-fe33906edaee",
          "layerType": "furniture"
        },
        {
          "id": "b3a51f19-2f3d-4f27-8d63-5558c0d69fb8",
          "name": "1C07",
          "furnitureId": "ea3c5ed7-8877-4123-9694-9083fc9d5bb0",
          "layerType": "furniture"
        },
        {
          "id": "e13fa82e-238e-46f1-87dd-74b9fe44f2fa",
          "name": "1C08",
          "furnitureId": "a4094cff-f3ff-41d3-8869-44bb85422eed",
          "layerType": "furniture"
        },
        {
          "id": "20223a1a-ad3b-499c-9775-968b36399141",
          "name": "1C09",
          "furnitureId": "1849be9f-377f-45c1-8ea9-af4ed5ba9d12",
          "layerType": "furniture"
        },
        {
          "id": "072c15b6-3dc2-4256-a2ca-84161c1f970f",
          "name": "1C10",
          "furnitureId": "f7301b2a-71d6-4005-b1a1-f3c7f0e41beb",
          "layerType": "furniture"
        },
        {
          "id": "c7371ff7-9b13-43a1-9be6-22cde785b4b1",
          "name": "1C11",
          "furnitureId": "d589ef64-066b-45d2-92cd-89ee84084972",
          "layerType": "furniture"
        },
        {
          "id": "775c62d2-770b-41a7-87ce-b713de8dc0a7",
          "name": "1C12",
          "furnitureId": "fd69d682-e75f-44c8-809b-f201e4866761",
          "layerType": "furniture"
        },
        {
          "id": "2d51398f-9ade-477e-80ec-d24dcc7bf2f4",
          "name": "1C13",
          "furnitureId": "56c67aec-cd72-4eb2-b2c1-44dedae52809",
          "layerType": "furniture"
        },
        {
          "id": "4639eeb5-16f6-432e-8730-bb2054bee70d",
          "name": "1C14",
          "furnitureId": "a6675890-cca2-45ba-9951-dc7da85a58d2",
          "layerType": "furniture"
        },
        {
          "id": "835d1ed0-4a27-48b9-8f68-956167f9b2b6",
          "name": "1C15",
          "furnitureId": "00dd900e-5c03-43e0-a73b-206cdacdd86b",
          "layerType": "furniture"
        },
        {
          "id": "e0858329-f24f-47d0-b60f-b982e1861a21",
          "name": "1C16",
          "furnitureId": "b57de0a1-cb28-467d-af7f-f0c1c83323fd",
          "layerType": "furniture"
        },
        {
          "id": "55cd093e-94d9-41e2-9d73-95a03a791b8c",
          "name": "1C17",
          "furnitureId": "c561dd47-ddc6-4835-94fc-5dc3b612a9df",
          "layerType": "furniture"
        },
        {
          "id": "13fecd97-b545-49fb-be77-7359cb244b74",
          "name": "1C18",
          "furnitureId": "78809505-9d61-436f-9b3d-0e5a54ef4d3d",
          "layerType": "furniture"
        },
        {
          "id": "7f69a48c-0fb6-48c0-9de3-1ba9e380e52e",
          "name": "1C19",
          "furnitureId": "2705821c-2628-4e47-bcf7-01cfc4fffbe9",
          "layerType": "furniture"
        },
        {
          "id": "112dfdd3-4afb-4464-a583-60c33d76c8ac",
          "name": "1C20",
          "furnitureId": "51dad1b8-8076-4893-bc28-39ca6a6809ec",
          "layerType": "furniture"
        },
        {
          "id": "f3d0944b-4a68-4088-a18f-adc7e2aaf4ec",
          "name": "1C21",
          "furnitureId": "43cc804a-78ae-4b67-acab-191ae7fd504e",
          "layerType": "furniture"
        },
        {
          "id": "c8ac8e52-fe3a-420d-8c28-36b9dabca70b",
          "name": "1C22",
          "furnitureId": "32f30c9e-8761-47d5-bbbe-3abd4ba7968f",
          "layerType": "furniture"
        },
        {
          "id": "7df21afe-5c8c-4c39-9359-4e65934e96c1",
          "name": "1C23",
          "furnitureId": "7349f062-5a07-4223-8982-66f62bfcae26",
          "layerType": "furniture"
        },
        {
          "id": "58c25aca-3131-4bf0-98d1-9dbc3cc531a1",
          "name": "1C24",
          "furnitureId": "355f51e3-aef3-4d6a-860f-4689c0e9caf5",
          "layerType": "furniture"
        },
        {
          "id": "a68df519-bcc3-4bcb-8595-bc310cc9186a",
          "name": "1C25",
          "furnitureId": "183544b1-1a79-4127-8f4c-4ea8ccdfd104",
          "layerType": "furniture"
        },
        {
          "id": "26aa2dc2-9849-4d78-afeb-bbda90bca92b",
          "name": "1C26",
          "furnitureId": "653245fa-1a9a-45a1-83e1-6fbe2799e18d",
          "layerType": "furniture"
        },
        {
          "id": "14726f2c-f3ab-4d5c-a51f-d3a5277070a3",
          "name": "1C27",
          "furnitureId": "b39b58ce-8c08-4d39-8a36-f5adfcbd98cf",
          "layerType": "furniture"
        },
        {
          "id": "d2e4a028-605a-456f-b7f3-ba418cae829a",
          "name": "1C28",
          "furnitureId": "1d35f2b9-779f-461a-a8da-70f785b2107f",
          "layerType": "furniture"
        },
        {
          "id": "ac90d7cf-a5c2-4446-a30d-875dff44520f",
          "name": "1C29",
          "furnitureId": "a85570eb-deca-478c-b8ea-9f362311a04f",
          "layerType": "furniture"
        },
        {
          "id": "72657682-a2f8-46ad-9e1f-64ff07c37173",
          "name": "1C30",
          "furnitureId": "af6a6d7a-b7d6-43f3-82a1-abbe49802384",
          "layerType": "furniture"
        },
        {
          "id": "5c625b2b-055f-4bb5-9aed-28e6e47ee86e",
          "name": "1C31",
          "furnitureId": "42eec98e-baa5-4d21-824f-afbf05187029",
          "layerType": "furniture"
        },
        {
          "id": "6b61fdf5-a898-4739-91bf-4769c35b48f3",
          "name": "1C32",
          "furnitureId": "61d8aeeb-c8e9-4933-b582-106ae2edcf07",
          "layerType": "furniture"
        },
        {
          "id": "db5a263e-33cd-4d05-bd32-d149ae8204ce",
          "name": "1C33",
          "furnitureId": "e3f26405-67f8-4528-a66a-27ac49b05bf8",
          "layerType": "furniture"
        },
        {
          "id": "bdbb3576-647a-4d7a-b391-76506c68cb0a",
          "name": "1C34",
          "furnitureId": "b2826b29-a0b1-4796-a138-eae5c281b42c",
          "layerType": "furniture"
        },
        {
          "id": "8afe14e6-5f85-4438-a26e-78ed4108a889",
          "name": "1C35",
          "furnitureId": "530878dc-5963-48b0-bd41-a49208124fe2",
          "layerType": "furniture"
        },
        {
          "id": "bb6cc54f-6d36-4f2c-b609-f4a1c1dd8f54",
          "name": "1C36",
          "furnitureId": "6f5ceaab-5cd4-4c09-b1ce-9bd0bbc86b54",
          "layerType": "furniture"
        },
        {
          "id": "931d7047-b095-4afc-9d52-4c95bce3577f",
          "name": "1C37",
          "furnitureId": "e620018f-f05d-4f1b-a591-1b653979e8f9",
          "layerType": "furniture"
        },
        {
          "id": "ce84e45b-9a0f-4e37-8bc8-830f1680d1d2",
          "name": "1C38",
          "furnitureId": "e4bcbcf5-f3e5-4233-b222-71b1cd9e18f6",
          "layerType": "furniture"
        },
        {
          "id": "9a7bd49f-24cf-48ba-bf95-560182fef3f4",
          "name": "1C39",
          "furnitureId": "6f252676-ea2b-4fdd-87a1-a09fc7110e0a",
          "layerType": "furniture"
        },
        {
          "id": "65ccc68e-242c-482f-8538-22ea1290db1c",
          "name": "1C40",
          "furnitureId": "b5599f53-a85a-4fef-b4c3-19a332eb6ae9",
          "layerType": "furniture"
        },
        {
          "id": "cc2f2c0e-8ca6-44d0-b517-de43b9cb7671",
          "name": "1C41",
          "furnitureId": "602cbebf-9ab6-43da-82e2-7ba964425a83",
          "layerType": "furniture"
        },
        {
          "id": "a9db2e19-cdc9-44f6-85f9-5f5a26ef11a8",
          "name": "1C42",
          "furnitureId": "9ed9cc7d-e4b4-4e7a-a6b3-87df78052ea5",
          "layerType": "furniture"
        },
        {
          "id": "2029a2a9-fb19-408f-952d-b5fef27c5e4c",
          "name": "1C43",
          "furnitureId": "927433e1-ebe6-4dfd-8e86-37c3f5b3d05c",
          "layerType": "furniture"
        },
        {
          "id": "6615c9e3-0d7b-4ded-a550-7497579af236",
          "name": "1C44",
          "furnitureId": "0ebef673-a758-47a9-93be-e051a65a1afd",
          "layerType": "furniture"
        },
        {
          "id": "dc665dc1-0474-4bd9-980a-4fecf0fa5b9e",
          "name": "1C45",
          "furnitureId": "40302c06-fcf0-453f-8669-2831ad3f79c1",
          "layerType": "furniture"
        },
        {
          "id": "ea38de8e-bead-4c9d-bbef-648da2ac9adb",
          "name": "1C46",
          "furnitureId": "3431deec-c571-489e-a177-8a123dbc879c",
          "layerType": "furniture"
        },
        {
          "id": "22a155f8-317f-4f12-872f-d1b86b84530a",
          "name": "1C47",
          "furnitureId": "53b9744a-4e67-4a46-b3f8-0d5c244469f8",
          "layerType": "furniture"
        },
        {
          "id": "d200f125-163d-4205-9098-295d49feea50",
          "name": "1C48",
          "furnitureId": "ce2da662-8532-4b40-a4ff-6186804a288f",
          "layerType": "furniture"
        },
        {
          "id": "13f831fd-c225-484b-9dd4-8fb95d5a88f9",
          "name": "1C49",
          "furnitureId": "ab00b5f0-a7ca-4685-bd2c-8e9592bd33b8",
          "layerType": "furniture"
        },
        {
          "id": "5d827b84-3f7f-45dd-8111-4ae6fe87091e",
          "name": "1C50",
          "furnitureId": "3bed7c25-72bd-40fc-8dbc-55d98aabbd98",
          "layerType": "furniture"
        },
        {
          "id": "ca959a38-4743-45ae-831a-554c4078df87",
          "name": "1C51",
          "furnitureId": "30f9a31c-e7d0-4494-a1e1-4508f3b61e07",
          "layerType": "furniture"
        },
        {
          "id": "81fae1cc-f4eb-461a-b846-d7f94b3a5e78",
          "name": "1A32",
          "furnitureId": "e2af6541-3b84-4bd0-a418-e310e5412da1",
          "layerType": "furniture"
        },
        {
          "id": "6ab2c650-ae21-463f-8390-bd6dbde89c05",
          "name": "1A33",
          "furnitureId": "362ea6f0-ecbe-466a-95c8-82220e235cd8",
          "layerType": "furniture"
        },
        {
          "id": "81e8216d-1d08-4754-9485-fc0da7205bce",
          "name": "1C52",
          "furnitureId": "2b000e83-2001-42d2-a6f2-41086130bc88",
          "layerType": "furniture"
        }
     
      ],
      locationAssets: [
        {
          id: "53c88883-8018-4407-8b8b-5b08e4c84866",
          name: "ServiceCounter",
          furnitureId: "36a9891f-367a-4e6c-ac6d-ae45f0e85ddb",
          layerType: "furniture",
          location: "service_counter",
        },
        {
          id: "7cd29679-75e2-4eec-a992-941a98a40749",
          name: "Res",
          furnitureId: "e0f7e073-27de-4a44-9308-26501f342a06",
          layerType: "furniture",
          location: "res",
        },
      ],
    },

    "2f": {
      spaceId: "spc_vyvqclk6",
      bookShelves: [
        {
          id: "1727459a-e8cc-4263-8bbc-2def247d5285",
          name: "2A01",
          furnitureId: "c55bbbeb-3b46-416a-a0db-72da7a02c088",
          layerType: "furniture",
        },
        {
          id: "60accb8b-e47c-4d4f-b6ef-5a37d4a413a1",
          name: "2A02",
          furnitureId: "786e3c28-b5fc-4c22-a8c7-77140c8e05da",
          layerType: "furniture",
        },
        {
          id: "2b5a2bf9-7bd3-4ae0-8872-ff4ca0b026e9",
          name: "2A03",
          furnitureId: "324cb7c4-9bed-4d69-872b-a555490cca1a",
          layerType: "furniture",
        },
        {
          id: "0068d637-9ed9-4297-b4c4-3ef1589d8bee",
          name: "2A04",
          furnitureId: "cae6debd-4d18-4fc8-a4d2-e51fc7e56c2b",
          layerType: "furniture",
        },
        {
          id: "fbaeaa0d-cb98-4678-a2e8-752234e4989b",
          name: "2A05",
          furnitureId: "f8561d0d-a792-4291-976c-cd97420c9fb3",
          layerType: "furniture",
        },
        {
          id: "a248058a-d1b7-4260-9181-c6b8a662a91d",
          name: "2A06",
          furnitureId: "ac652397-6719-4761-82c8-41cd6feda332",
          layerType: "furniture",
        },
        {
          id: "3bcc8aeb-b7ea-4d0d-b125-140e47d27c47",
          name: "2A07",
          furnitureId: "94860a18-4475-4d98-9171-b72638dcf712",
          layerType: "furniture",
        },
        {
          id: "e260d647-69c9-4d22-873f-e9a56381e836",
          name: "2A08",
          furnitureId: "6cb338b0-3cd9-413d-af3f-e38b6469809c",
          layerType: "furniture",
        },
        {
          id: "50a90140-ba34-4c64-b39a-33d60bc7a4d3",
          name: "2A09",
          furnitureId: "917cd55f-143a-46b9-931a-668e2c516aac",
          layerType: "furniture",
        },
        {
          id: "4115810e-573f-4c66-91fd-74ed0186ae09",
          name: "2A10",
          furnitureId: "3a7974f2-15a0-4c62-b3c3-40361aa43c16",
          layerType: "furniture",
        },
        {
          id: "02adc9df-0fd7-485b-ac1d-f06e672079e7",
          name: "2A11",
          furnitureId: "96e21748-6676-46db-ab9d-6c7b1f92200c",
          layerType: "furniture",
        },
        {
          id: "26102806-3235-4c08-9bc1-2632cad41e1e",
          name: "2A12",
          furnitureId: "9f31aafd-20f2-4866-8433-bc4b3baf51f0",
          layerType: "furniture",
        },
        {
          id: "020c961b-4e35-4c23-bda1-044efb59ac05",
          name: "2A13",
          furnitureId: "67e72ce6-c7ae-495e-a118-abb105a7e536",
          layerType: "furniture",
        },
        {
          id: "3e466842-9de8-49c3-b020-e6ec3a0fded5",
          name: "2A14",
          furnitureId: "fc91e751-f7b3-4856-92cd-89ddbcba1c02",
          layerType: "furniture",
        },
        {
          id: "b00235d4-d5a3-4bdb-9ee1-d481fcfac7e0",
          name: "2A15",
          furnitureId: "872efea0-72f9-4f09-9e81-88ba15c8271e",
          layerType: "furniture",
        },
        {
          id: "339d7ec5-8a3e-47a6-a27c-ecb75791c428",
          name: "2A16",
          furnitureId: "960c01a1-7ae3-45c2-9eda-3023b6442fa2",
          layerType: "furniture",
        },
        {
          id: "0cc0920b-f058-4aa9-81aa-fc52fd995317",
          name: "2B01",
          furnitureId: "92a9b2ac-cdfa-479f-8dda-6635d58bf1ba",
          layerType: "furniture",
        },
        {
          id: "6b29764c-ec9c-4c2e-9fbd-f2e5aba99ed1",
          name: "2B02",
          furnitureId: "b2766e86-0806-4007-8ade-23aa0c6f506d",
          layerType: "furniture",
        },
        {
          id: "3999a195-727f-4c0d-97d8-c18a91eb950a",
          name: "2B03",
          furnitureId: "2418b769-ef4d-4477-ae6e-0ca4de40149f",
          layerType: "furniture",
        },
        {
          id: "ec949863-6901-4c9c-b81b-2746fff018c5",
          name: "2C01",
          furnitureId: "145e5cc3-397e-4033-8e31-ece819adacae",
          layerType: "furniture",
        },
        {
          id: "d859b6e8-343a-4adc-9b94-f5ed0fa256f3",
          name: "2A17",
          furnitureId: "8a029e32-5149-42ce-a809-444f883efbf8",
          layerType: "furniture",
        },
      ],
    },
    "3f": {
      spaceId: "spc_v2qssnrl",
      bookShelves: [
        {
          id: "fe04fc34-f554-4861-9a1f-f2e54c98c063",
          name: "3A01",
          furnitureId: "807f23df-e6b6-4c6b-9b30-196b73585e09",
          layerType: "furniture",
        },
        {
          id: "59967c16-259c-4198-9c04-b701ebe0b356",
          name: "3A02",
          furnitureId: "626b7c26-b157-449e-b276-a8e5d5242749",
          layerType: "furniture",
        },
        {
          id: "8e70082d-44b9-42a1-b7fd-2aaaabd695ed",
          name: "3A03",
          furnitureId: "2866de7d-2ef5-4339-b24c-19b27a8c4138",
          layerType: "furniture",
        },
        {
          id: "274bcb0c-760a-4947-8025-305029c694c7",
          name: "3A04",
          furnitureId: "270149b1-259e-45fb-803f-4e957e0c132e",
          layerType: "furniture",
        },
        {
          id: "69b636c1-9708-408f-9c17-b3c8903ac95c",
          name: "3A05",
          furnitureId: "e26dcfff-ed74-45bb-95c6-caad5d635844",
          layerType: "furniture",
        },
        {
          id: "d32465fb-92ad-4c4d-95c6-920f4b576f05",
          name: "3A06",
          furnitureId: "675aaad8-cca8-4389-a96d-45d4c6c247c1",
          layerType: "furniture",
        },
        {
          id: "ba47f2fb-1acb-4b25-ab59-e96300bc7732",
          name: "3A07",
          furnitureId: "675e26e1-062a-49ee-9b9e-532a23f22720",
          layerType: "furniture",
        },
        {
          id: "3bd400c1-6918-450b-8aec-b7f689671bf8",
          name: "3A08",
          furnitureId: "f0a50109-af97-4071-bd77-377af38c2b13",
          layerType: "furniture",
        },
        {
          id: "067fc4cd-9a13-4f36-a1af-5116d60dd5a8",
          name: "3A09",
          furnitureId: "d50a7315-694f-436a-8180-395e5b253920",
          layerType: "furniture",
        },
        {
          id: "91766133-de13-45be-8971-5cb7e66085b1",
          name: "3A10",
          furnitureId: "47a0ef2a-2778-4804-b67a-166303b228bd",
          layerType: "furniture",
        },
        {
          id: "946978fb-4ee1-4d04-a315-d940636cb262",
          name: "3A11",
          furnitureId: "0c2c87a4-14e3-4e4d-a143-0b454663dbfa",
          layerType: "furniture",
        },
        {
          id: "e86adf14-6bb0-43c4-b1a5-5e3bfebb4e97",
          name: "3A12",
          furnitureId: "f21b514c-810b-494e-b291-b2b12996e7be",
          layerType: "furniture",
        },
        {
          id: "e9be8865-618f-4b3e-848a-d38668249532",
          name: "3A13",
          furnitureId: "00e6d7a9-6d04-4a9b-95c2-641d846597d8",
          layerType: "furniture",
        },
        {
          id: "c6ddcd31-2891-46cd-afcd-b070277cfc5d",
          name: "3A14",
          furnitureId: "442df79a-1bbd-444b-9eed-660d8d3eb9cb",
          layerType: "furniture",
        },
        {
          id: "2b49e728-2304-42a2-83db-f62986205489",
          name: "3A15",
          furnitureId: "3b97508f-93a7-4be5-8656-7f50ea907d64",
          layerType: "furniture",
        },
        {
          id: "34b30c56-8f38-4d4b-adc0-3ddf7a43dc3a",
          name: "3A16",
          furnitureId: "150d8a32-9b0c-41ce-b940-2c3f9c238c81",
          layerType: "furniture",
        },
        {
          id: "d3a8e6af-795d-4e64-a8e2-d4226aca9981",
          name: "3A17",
          furnitureId: "8af3e625-463f-484c-8815-60f5e2c7d296",
          layerType: "furniture",
        },
        {
          id: "00f83069-a817-4b60-91df-911c5b1322d9",
          name: "3B01",
          furnitureId: "f8b76780-61bd-441a-ab18-a1986b556847",
          layerType: "furniture",
        },
        {
          id: "8653f674-07ac-4670-9e49-dcfff6f82382",
          name: "3B02",
          furnitureId: "5c330546-c0fe-458b-a123-3ee70ecbdc67",
          layerType: "furniture",
        },
        {
          id: "7a0b30d0-719d-4464-95e0-5f7196610871",
          name: "3B03",
          furnitureId: "3de9120a-dad6-40ae-b235-581b6445f462",
          layerType: "furniture",
        },
        {
          id: "90e86731-a99b-4962-b484-a5de29996f8c",
          name: "3B04",
          furnitureId: "282db199-d2ef-4ce1-82e4-03ecba500a86",
          layerType: "furniture",
        },
        {
          id: "284d728a-6112-4e57-9d1f-e42901a14c99",
          name: "3B05",
          furnitureId: "67c6ddf7-c365-4d99-ae13-70a7d87e651c",
          layerType: "furniture",
        },
        {
          id: "692511c0-ecfe-44f5-a130-87a6baf92dad",
          name: "3B06",
          furnitureId: "79b19978-ab2d-4774-a864-1ff39f550bf3",
          layerType: "furniture",
        },
        {
          id: "3b1ef98a-0fb9-4954-a7e9-a3ec69565463",
          name: "3B07",
          furnitureId: "a6cc7a0f-ab38-4bfb-927e-9cebfa69aee6",
          layerType: "furniture",
        },
        {
          id: "2ee349b3-5dab-4b78-9bf2-a678fc67a672",
          name: "3B08",
          furnitureId: "5d1ba20a-461e-4e5d-8400-95e9d42cb840",
          layerType: "furniture",
        },
        {
          id: "f25993bc-303a-4454-b892-b5d2d8dd80e6",
          name: "3B09",
          furnitureId: "8fee0771-7124-4c0f-9799-c46edd3f992e",
          layerType: "furniture",
        },
        {
          id: "82309b8b-b656-40d3-acce-dd6b52644d3a",
          name: "3B10",
          furnitureId: "e526474a-e45a-4ab6-b8ce-58cc9f2dc739",
          layerType: "furniture",
        },
        {
          id: "853835e8-cb5c-43d5-b551-f8dc5729f09b",
          name: "3B11",
          furnitureId: "6c93aab3-3a54-4ecf-b142-5a267da9f7c9",
          layerType: "furniture",
        },
        {
          id: "a04eebcf-2df6-4ebb-82bf-8bf3dc4623f1",
          name: "3B12",
          furnitureId: "f8b285e2-133c-4191-87d8-55a44328a6bd",
          layerType: "furniture",
        },
        {
          id: "6c47dc95-6a99-48d1-90d2-4a1a4b232044",
          name: "3B13",
          furnitureId: "fb0d717f-cd41-4f7b-a335-c3ba85802fc6",
          layerType: "furniture",
        },
        {
          id: "8ee440ea-d682-4efa-b5e2-1e3fb828b60a",
          name: "3B14",
          furnitureId: "4030c3e1-bd40-465b-99bd-1c9c2f377f6d",
          layerType: "furniture",
        },
        {
          id: "f21fe107-b880-4a59-935e-396898afc7c7",
          name: "3B15",
          furnitureId: "7b88e82e-f313-46a8-a86a-edc6744068d2",
          layerType: "furniture",
        },
        {
          id: "9f449153-8233-4bd9-b68f-3be79f889af8",
          name: "3C01",
          furnitureId: "a73f568a-f307-4635-a4b0-4639b24a8b3e",
          layerType: "furniture",
        },
        {
          id: "6b69d588-299c-4647-998d-5a7a80003402",
          name: "3C02",
          furnitureId: "67a47211-611f-46db-8a59-240db7de2798",
          layerType: "furniture",
        },
        {
          id: "12bf5ca3-d738-4517-9fd0-39d4123e4a66",
          name: "3C03",
          furnitureId: "a3b108ea-395f-4bd5-be2a-0fa20c343b47",
          layerType: "furniture",
        },
        {
          id: "c8b08102-f2e0-4303-bee1-85db07199a48",
          name: "3C04",
          furnitureId: "fac74240-8163-49e9-9c14-fd8be7eef47e",
          layerType: "furniture",
        },
        {
          id: "4f6761d8-2880-4e4b-8d91-c66b1f75bf6e",
          name: "3C05",
          furnitureId: "3e3054af-c899-49cf-98f0-d15a354aedc2",
          layerType: "furniture",
        },
        {
          id: "579a4332-19c8-44b9-bfa8-f4fe8e22cc20",
          name: "3C06",
          furnitureId: "18e6eaca-170e-4333-8e7f-1a902c652e72",
          layerType: "furniture",
        },
        {
          id: "7cb936f3-6fd3-47e0-849f-962101c18e07",
          name: "3C07",
          furnitureId: "31542a32-15bd-4df1-b9fa-a59382db2f1a",
          layerType: "furniture",
        },
        {
          id: "454794d8-9542-45b8-9fe1-e45f3a278ed6",
          name: "3C08",
          furnitureId: "4cadb6c8-e3e4-4e07-92fc-50ddee12dde8",
          layerType: "furniture",
        },
        {
          id: "de2d205d-8ccb-45c3-9661-9f03f7593b09",
          name: "3C09",
          furnitureId: "e4e8bb82-86e0-485c-9198-f91de9ab7b6d",
          layerType: "furniture",
        },
        {
          id: "38478d50-1dc1-4640-b88c-226c9693949d",
          name: "3C10",
          furnitureId: "9a01331c-c9a3-4658-a593-b3494bc9dbe5",
          layerType: "furniture",
        },
        {
          id: "d00984f6-9bbf-4465-958f-ac05533bab02",
          name: "3C11",
          furnitureId: "898cc33f-e214-4669-8300-5d1b051e43d3",
          layerType: "furniture",
        },
        {
          id: "d30f46ef-e2e2-4810-9b14-de363bca6f74",
          name: "3C12",
          furnitureId: "ccfff782-7f97-4915-bafe-a86bda5f5bb0",
          layerType: "furniture",
        },
        {
          id: "fe462087-e81e-4d80-a2c9-9db751663276",
          name: "3C13",
          furnitureId: "bb02cd5a-ec12-48d7-b18d-d227b1f7950d",
          layerType: "furniture",
        },
        {
          id: "f5e696b2-b441-4f0f-b44c-7274333f8dcc",
          name: "3C14",
          furnitureId: "87bf75dd-b69e-4ac1-8eb7-0a4e6a7acc70",
          layerType: "furniture",
        },
        {
          id: "8789d178-f69d-4271-addf-7c854f800fd0",
          name: "3C15",
          furnitureId: "8c6537bc-f267-4b40-ad00-d9a649ed26c2",
          layerType: "furniture",
        },
        {
          id: "2ca2594c-5f14-4b6d-b977-3fba34616c6f",
          name: "3C16",
          furnitureId: "a8356fa8-dd3e-4525-945a-3ca3e9b4ca14",
          layerType: "furniture",
        },
        {
          id: "9dfbf363-419a-4457-97da-6b9346298c34",
          name: "3C17",
          furnitureId: "2b99c485-a79c-4808-828e-bd2d803a5778",
          layerType: "furniture",
        },
        {
          id: "8b12e802-85f9-4f9a-a320-a4380a99f1c8",
          name: "3C18",
          furnitureId: "341627de-58a7-4885-a677-2577abb39284",
          layerType: "furniture",
        },
        {
          id: "06ed64e7-6a80-4734-bec1-24c1c0001dc3",
          name: "3C19",
          furnitureId: "69307403-04f9-43ce-886e-0db62d759d08",
          layerType: "furniture",
        },
        {
          id: "889f538a-be89-476a-8da1-c88c0a4a6649",
          name: "3C20",
          furnitureId: "3fc432a3-e237-4180-8fb9-2c97bfbcca7f",
          layerType: "furniture",
        },
        {
          id: "d99e0b3a-6470-4108-a950-735635ccb519",
          name: "3C21",
          furnitureId: "1129d946-8d62-4bf2-9c2b-736bf8dbe82b",
          layerType: "furniture",
        },
        {
          id: "e4f5ede0-bc2f-45d0-bccc-f57aef42c8b3",
          name: "3C22",
          furnitureId: "24ec6c08-9bb8-4c3d-a2c8-1f4ed953abfa",
          layerType: "furniture",
        },
        {
          id: "0547fb80-de85-4c94-ba41-8b26d18a1377",
          name: "3C23",
          furnitureId: "a73f52fc-7a30-4107-90e0-67b3947a1a0c",
          layerType: "furniture",
        },
        {
          id: "4cc0731a-25b0-40ec-82c2-de2ca61d3c3d",
          name: "3C24",
          furnitureId: "e4b18f05-f2f7-4e5f-be0a-e51c8bb8b3d8",
          layerType: "furniture",
        },
        {
          id: "5989a219-a23d-45e3-a84f-f7cc9c094b44",
          name: "3C25",
          furnitureId: "c099ee28-0470-46c9-bcc4-7e559b63b705",
          layerType: "furniture",
        },
        {
          id: "1c4762b2-b328-43a6-8b5f-e32506b2f339",
          name: "3C26",
          furnitureId: "ecbc3d8c-55cb-40b7-ac5b-ad14c48b1621",
          layerType: "furniture",
        },
        {
          id: "2e2a81c1-47ab-498a-b281-c86acdb2e1eb",
          name: "3C27",
          furnitureId: "857c83b1-0810-4425-ba99-7a35407acc09",
          layerType: "furniture",
        },
        {
          id: "b048020b-af9e-45bc-982d-6ed54d5298d2",
          name: "3C28",
          furnitureId: "a889f748-7af5-470d-ba89-163a1c1e435e",
          layerType: "furniture",
        },
        {
          id: "bed87868-64eb-4467-9806-9de5f87434f9",
          name: "3C29",
          furnitureId: "e3d551c7-e223-4828-ae6a-a772eb5775cc",
          layerType: "furniture",
        },
        {
          id: "b7f1642a-1a4e-4223-a956-8a40919c3721",
          name: "3C30",
          furnitureId: "d26af154-fb25-461a-bdd1-1293aa42419a",
          layerType: "furniture",
        },
        {
          id: "49704f54-2e72-4f7d-9652-ed76235f1f77",
          name: "3C31",
          furnitureId: "9e7e0f08-8610-47cb-90aa-533a1f16bf0b",
          layerType: "furniture",
        },
        {
          id: "b08cc0b0-75f4-45cc-a2a1-7739a52e20b5",
          name: "3C32",
          furnitureId: "1b027147-b21a-45f0-a720-008d20735a09",
          layerType: "furniture",
        },
        {
          id: "801d3317-d514-4fe9-aa9c-a3c75d58a292",
          name: "3C33",
          furnitureId: "4a66b455-6ac7-46e4-823d-d687716afd2e",
          layerType: "furniture",
        },
        {
          id: "d4430bee-8f5f-4e89-8e0b-1cae3c072258",
          name: "3C34",
          furnitureId: "f51fed97-b821-4e66-96f0-156255ee8cf9",
          layerType: "furniture",
        },
        {
          id: "df1112a3-8a86-48c0-bb7b-e56e110b9098",
          name: "3C35",
          furnitureId: "72d8a06c-740b-474d-b572-e25f9f81cad4",
          layerType: "furniture",
        },
        {
          id: "fde69fcb-44e7-4628-bab7-f62b5a4a8b9b",
          name: "3C36",
          furnitureId: "ba1c506e-df1f-48a6-a2a9-93b4d932e5f4",
          layerType: "furniture",
        },
        {
          id: "8b2ded1e-fe0c-47fb-9982-853fe010875e",
          name: "3C37",
          furnitureId: "95c21b01-3afd-403f-8a2b-2860f1d6afe4",
          layerType: "furniture",
        },
        {
          id: "d6b9a883-f520-462e-8907-e6c026cb6a12",
          name: "3C38",
          furnitureId: "09591e4c-092e-4e49-8385-ad61b3d32ebf",
          layerType: "furniture",
        },
        {
          id: "62358261-07b0-430e-b0c1-51cc892657d1",
          name: "3C39",
          furnitureId: "59e96d23-8e12-41c6-96d2-ee99dc82b738",
          layerType: "furniture",
        },
        {
          id: "881b06d9-cb18-46d4-a1e8-8d53ec6d4305",
          name: "3C40",
          furnitureId: "39d0e8fb-d27b-4687-a09c-417ed1705142",
          layerType: "furniture",
        },
        {
          id: "b52a5a09-2e92-4c6b-b933-7cb797c2b852",
          name: "3C41",
          furnitureId: "0a2f9bec-1faf-41cc-985a-f0eb8f09024e",
          layerType: "furniture",
        },
        {
          id: "ee4c326d-0062-4d95-bfc7-7791dbaf43b1",
          name: "3C42",
          furnitureId: "0d6e5063-8ae0-411a-86ec-879ccbded9c0",
          layerType: "furniture",
        },
        {
          id: "6df65fe0-742d-41c6-b513-adf47dd5ff55",
          name: "3C43",
          furnitureId: "c2777c26-ce72-4562-9ffa-fa5ab399ddcd",
          layerType: "furniture",
        },
        {
          id: "7a4d1b3c-63cd-4708-94a2-c7bad47572c1",
          name: "3C44",
          furnitureId: "d9470431-a218-42da-b665-b19cf3f800c4",
          layerType: "furniture",
        },
        {
          id: "a6eb22e3-b416-4865-a2f7-9ccdeb8abcb2",
          name: "3C45",
          furnitureId: "e88f2062-191f-4daf-b0a4-e3f690c120ac",
          layerType: "furniture",
        },
        {
          id: "d0abac66-538f-4165-9d1c-88c3af92a5de",
          name: "3C46",
          furnitureId: "5c1cf349-c95b-41ce-a563-de0e96ca22c1",
          layerType: "furniture",
        },
        {
          id: "7b286101-ad63-4c77-8b82-c443abbef7fa",
          name: "3C47",
          furnitureId: "842b8d63-2c33-42c3-9507-3b8653578526",
          layerType: "furniture",
        },
        {
          id: "fe9d6f67-7978-4750-a29a-39cf7e216d72",
          name: "3C48",
          furnitureId: "ea961f6c-e504-4354-8208-8a9b8858d9f1",
          layerType: "furniture",
        },
        {
          id: "515d77e3-380a-4674-b96f-0465ded9c704",
          name: "3C49",
          furnitureId: "3ddd6c65-1a4e-4e97-98f9-f27cdb53a08c",
          layerType: "furniture",
        },
        {
          id: "b32af43f-1e31-4ce9-9a38-3912e9d9d712",
          name: "3C50",
          furnitureId: "e2bac40e-92ef-4b3b-bb54-69fc8e6f362e",
          layerType: "furniture",
        },
        {
          id: "478e4b49-2454-4ec5-92ad-5a1712d99d07",
          name: "3C51",
          furnitureId: "6d073eee-4b3f-4814-823b-7dacfb873669",
          layerType: "furniture",
        },
        {
          id: "b3c75c3a-6ae0-4b8d-93a8-05a78c18ff9e",
          name: "3C52",
          furnitureId: "ee522278-69e8-4040-a169-1c433763897b",
          layerType: "furniture",
        },
        {
          id: "bf91854c-ffff-49d6-884c-b78b57336634",
          name: "3C53",
          furnitureId: "1923a5c0-863f-4632-af00-083fc7674348",
          layerType: "furniture",
        },
        {
          id: "6d95c106-8b7d-48d7-82e6-ffa1491778d8",
          name: "3C54",
          furnitureId: "b24f0a7f-b0db-4371-a58a-e8c28ab1f7e7",
          layerType: "furniture",
        },
        {
          id: "a686e6be-27c6-490e-afc2-fec7fb473558",
          name: "3C55",
          furnitureId: "8a7143af-c58f-4d37-adfb-a2e05a554d93",
          layerType: "furniture",
        },
        {
          id: "f2e72de7-9855-4640-b650-41aaad9de20b",
          name: "3C56",
          furnitureId: "65ce83b9-ade6-4a5e-9279-0c0d43bd0f7f",
          layerType: "furniture",
        },
        {
          id: "d4a07f05-1324-40fd-8317-dccef275958e",
          name: "3C57",
          furnitureId: "d80d65e2-2b9b-4e9d-8929-5f6408d93a4e",
          layerType: "furniture",
        },
        {
          id: "fd609170-ada9-4bfc-a8d1-652505caaea8",
          name: "3C58",
          furnitureId: "5adaf706-52b0-47c4-9af1-49e84487e605",
          layerType: "furniture",
        },
        {
          id: "ad62bede-2a93-4981-959d-a351f2bac5cd",
          name: "3C59",
          furnitureId: "108afbb5-490f-4867-a94b-b4151ceb0fea",
          layerType: "furniture",
        },
        {
          id: "7c088802-0ad9-4df2-b249-51a6aab8c602",
          name: "3C60",
          furnitureId: "7c186142-751c-44ed-8c68-51dae1d9ed33",
          layerType: "furniture",
        },
        {
          id: "e4e28b18-bc57-41eb-8f0e-feb5d91d5888",
          name: "3C61",
          furnitureId: "dfa1b4b2-4dc1-4c39-9c4d-cad732b35f7f",
          layerType: "furniture",
        },
        {
          id: "94455efb-5e80-4ced-8c54-2be4d423ad8f",
          name: "3C62",
          furnitureId: "9404543b-de1b-436e-9c09-bd2a24df2b7f",
          layerType: "furniture",
        },
        {
          id: "26b42db0-7e00-4f87-aa30-59cd410ada23",
          name: "3C63",
          furnitureId: "4240dfc4-e81f-413a-821c-04aeef463ba3",
          layerType: "furniture",
        },
        {
          id: "21cef959-f278-4afd-aa04-4e8ed3ed180c",
          name: "3C64",
          furnitureId: "5ece5304-f84f-4088-938d-e2486ed788cd",
          layerType: "furniture",
        },
        {
          id: "515e5ad7-02f7-4dee-a17d-4d9ff0c48feb",
          name: "3C65",
          furnitureId: "cd298c96-55f0-4e4b-b34a-494a0537b078",
          layerType: "furniture",
        },
        {
          id: "eb1c0704-5f87-40c0-9e4d-c6c06806bab7",
          name: "3C66",
          furnitureId: "2c2a9a93-084a-4656-a266-7bb94cebd49e",
          layerType: "furniture",
        },
      ],
    },
    mf: {
      spaceId: "spc_xmv1nsbw",
      bookShelves: [
        {
          "id": "5af64fff-72ef-46c1-aa42-2e551759bf4f",
          "name": "MB01-1",
          "furnitureId": "7068007e-0efa-40b5-b97e-4144f57f548c",
          "layerType": "furniture"
        },
        {
          "id": "62986218-97c6-42ab-93c9-6787198585d5",
          "name": "MB01-2",
          "furnitureId": "591aff36-d1b3-428c-a511-f68f0d2f9210",
          "layerType": "furniture"
        },
        {
          "id": "6716d2d3-7a86-47d6-a90c-dcd06a5dfc81",
          "name": "MB01-3",
          "furnitureId": "ff16d96b-032f-41ff-9136-7b2e58a75ced",
          "layerType": "furniture"
        },
        {
          "id": "3b7fc10e-56df-4775-b07b-2db77736634f",
          "name": "MB01-4",
          "furnitureId": "3623b243-0909-4912-bbe2-f24e6ec29dbd",
          "layerType": "furniture"
        },
        {
          "id": "0b69cf5e-7771-4d33-9db1-bf3515a1f2c6",
          "name": "MB01-5",
          "furnitureId": "40a3f430-a836-4142-bebc-40d625dabf54",
          "layerType": "furniture"
        },
        {
          "id": "633bccc7-aa4c-4e89-87f8-ca970737e5a7",
          "name": "MB01-6",
          "furnitureId": "00febfa8-359a-418d-9d09-2e0fe20f223c",
          "layerType": "furniture"
        },
        {
          "id": "e9aa253a-19ce-4593-a8b5-ba7df944ef80",
          "name": "MB02-1",
          "furnitureId": "07c32ab6-a292-4cf0-b1a5-a42a1876ae7b",
          "layerType": "furniture"
        },
        {
          "id": "39367f92-7070-40ff-b2fb-76290121a58a",
          "name": "MB02-2",
          "furnitureId": "60cdef41-30d6-4418-b96a-373be5a03566",
          "layerType": "furniture"
        },
        {
          "id": "6ea4c053-062c-4d46-96cd-6065f03fecec",
          "name": "MB02-3",
          "furnitureId": "44b546c6-a491-4ef7-bda5-2db33e4f40ce",
          "layerType": "furniture"
        },
        {
          "id": "4c220b44-5a35-48b4-9828-4f8aef8b0f1e",
          "name": "MB02-4",
          "furnitureId": "4e042ea5-5a64-4d7c-a5ba-dab6b1c1e3dc",
          "layerType": "furniture"
        },
        {
          "id": "d43a5efa-e527-4836-ae9d-796c4e316e5d",
          "name": "MB02-5",
          "furnitureId": "af05ba4c-24de-42b9-b7a7-23321b486243",
          "layerType": "furniture"
        },
        {
          "id": "7fafd700-1bea-4c9e-9dc6-6d0a8e64d7bd",
          "name": "MB02-6",
          "furnitureId": "d31d70d7-949d-4655-9a19-85c52e0266a8",
          "layerType": "furniture"
        },
        {
          "id": "a34dd976-9138-460c-9689-8c5b2e935dd8",
          "name": "MB02-7",
          "furnitureId": "3b4215c8-4c0d-42f9-9ee2-f10577c955a5",
          "layerType": "furniture"
        }
      ],
    },
  };

  // Get URL parameters with case-insensitive fallback
  const getQueryParameter = (param) => {
    const url = new URL(window.location.href);
    // Try exact match first
    let value = url.searchParams.get(param);
    if (value) return value;

    // Try lowercase fallback
    value = url.searchParams.get(param.toLowerCase());
    if (value) return value;

    // Try uppercase fallback
    value = url.searchParams.get(param.toUpperCase());
    return value;
  };

  // Set camera position based on shelf location
  const setCameraPosition = (shelfName) => {
    if (!spaceRef.current) return;

    setTimeout(() => {
      try {
        const cameraConfig = {
          animated: true,
          speed: 0.1,
        };
        if (shelfName.startsWith("1C")) {
          spaceRef.current.setCameraPlacement({
            alpha: 1.566796326794897,
            beta: 0.17702645662417016,
            radius: 90.75737929330322,
            target: {
              x: 70.43136145449171,
              y: 1,
              z: -48.228182803491535,
            },

            animated: true,
          });
        } else if (shelfName.startsWith("1FC")) {
          spaceRef.current.setCameraPlacement({
            alpha: 1.566796326794897,
            beta: 0.17702645662417016,
            radius: 90.75737929330322,
            target: {
              x: 70.43136145449171,
              y: 1,
              z: -48.228182803491535,
            },
            animated: true,
          });
        } else if (shelfName.startsWith("1FS")) {
          spaceRef.current.setCameraPlacement({
            alpha: 1.566796326794897,
            beta: 0.17702645662417016,
            radius: 90.75737929330322,
            target: {
              x: 70.43136145449171,
              y: 1,
              z: -48.228182803491535,
            },
            animated: false,
          });
        }else if (shelfName.startsWith("2A")) {
          // Camera position for 2B shelves (floor 2f)
          spaceRef.current.setCameraPlacement({
            alpha: -1.5722224976673886,
            beta: 0.7099240223592373,
            radius: 65.566640313453746,
            target: { x: 31.2418383712391, y: 16, z: -53.20580854095632 },
            animated: true,
          });
        }else if (shelfName.startsWith("2B")) {
          // Camera position for 2B shelves (floor 2f)
          spaceRef.current.setCameraPlacement({
            alpha: -1.5722224976673886,
            beta: 0.7099240223592373,
            radius: 65.566640313453746,
            target: { x: 31.2418383712391, y: 16, z: -53.20580854095632 },
            animated: true,
          });
        } else if (shelfName.startsWith("2C")) {
          // Camera position for 2C shelves (floor 2f)
          spaceRef.current.setCameraPlacement({
            alpha: -1.5722224976673886,
            beta: 0.7099240223592373,
            radius: 65.566640313453746,
            target: { x: 31.2418383712391, y: 16, z: -53.20580854095632 },
          });
        }else if (shelfName.startsWith("2")) {
          // Camera position for 2B shelves (floor 2f)
          spaceRef.current.setCameraPlacement({
            alpha: -1.5722224976673886,
            beta: 0.7099240223592373,
            radius: 65.566640313453746,
            target: { x: 31.2418383712391, y: 16, z: -53.20580854095632 },
            animated: true,
          });
        } else if (shelfName.startsWith("3") || locationCode.startsWith("3")) {
          // Camera position for floor 3f shelves
          spaceRef.current.setCameraPlacement({
            alpha: -1.5721425958892115,
            beta: 0.7099240223592373,
            radius: 80.84028674223195,
            target: { x: 36.719494692293786, y: 10, z: -46.63437307052993 },
            animated: true,
          });
        } else if (locationCode.startsWith("m")) {
          // Camera position for floor mf shelves
          spaceRef.current.setCameraPlacement({
            alpha: 1.5642931020318165,
            beta: 0.7099240223592373,
            radius: 71.228814129728086,
            target: {
              x: 69.04755001887268,
              y: 1,
              z: -44.24558015977757,
            },
            animated: true,
          });
        } else {
          // Default camera position (floor 1f)
          spaceRef.current.setCameraPlacement({
            alpha: 1.566796326794897,
            beta: 0.17702645662417016,
            radius: 90.75737929330322,
            target: {
              x: 70.43136145449171,
              y: 1,
              z: -48.228182803491535,
            },

            animated: true,
          });
        }
      } catch (e) {
        console.log("Camera positioning error:", e);
      }
    }, 1000);
  };

  // Helper function to determine floor from shelf number
  const getFloorFromShelfNumber = (shelfNumber) => {
    if (!shelfNumber) return null;

    if (shelfNumber.startsWith("1")) return "1f";
    if (shelfNumber.startsWith("2")) return "2f";
    if (shelfNumber.startsWith("3")) return "3f";
    if (shelfNumber.startsWith("M")) return "mf";

    return null;
  };

  // NEW: Function to determine correct floor before initialization
  const determineCorrectFloor = async (locationCode, callNumber) => {
    // For circ, always use 1f
    if (locationCode === "circ") {
      return "1f";
    }

    // If we have a call number, make API call to get shelf number
    if (callNumber) {
      try {
        const apiUrl = `${API_ENDPOINT}?locationCode=${encodeURIComponent(
          locationCode
        )}&callNumber=${encodeURIComponent(callNumber)}`;
        const response = await fetch(apiUrl);

        if (response.ok) {
          const data = await response.json();
          const dataArray = Array.isArray(data) ? data : [data];

          if (dataArray.length > 0 && dataArray[0].book_shelf_number) {
            const detectedFloor = getFloorFromShelfNumber(
              dataArray[0].book_shelf_number
            );
            if (detectedFloor && floorConfigs[detectedFloor]) {
              console.log(
                `Detected floor ${detectedFloor} from shelf ${dataArray[0].book_shelf_number}`
              );
              return detectedFloor;
            }
          }
        }
      } catch (error) {
        console.warn("Could not determine floor from API, using default");
      }
    }

    // For direct floor codes
    if (floorConfigs[locationCode]) {
      return locationCode;
    }

    // Default fallback
    return "1f";
  };

  // Search for books and highlight shelves
  // Simplified search function since floor is already correct
  const searchBooksAndHighlight = async (locationCode, callNumber, config) => {
    try {
      const apiUrl =
        callNumber || locationCode === "circ"
          ? `${API_ENDPOINT}?locationCode=${encodeURIComponent(
              locationCode
            )}&callNumber=${encodeURIComponent(callNumber || "")}`
          : `${API_ENDPOINT}?locationCode=${encodeURIComponent(locationCode)}`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response for highlighting:", data);

      const dataArray = Array.isArray(data) ? data : [data];
      const bookShelvesMap = {};
      config.bookShelves.forEach((shelf) => {
        bookShelvesMap[shelf.name] = shelf;
      });

      const matchingShelves = [];

// EXPLICIT MAPPING: circ location → 1A30 shelf
if (locationCode === "circ") {
  const targetShelf = bookShelvesMap["1A30"];
  if (targetShelf) {
    matchingShelves.push({
      ...targetShelf,
      bookData: dataArray[0] || {},
    });
  }
} else {
  // Original logic for other locations
  dataArray.forEach((bookItem) => {
    const shelfName = bookItem.book_shelf_number;
    if (shelfName && bookShelvesMap[shelfName]) {
      const shelfWithBookData = {
        ...bookShelvesMap[shelfName],
        bookData: bookItem,
      };
      matchingShelves.push(shelfWithBookData);
    }
  });

  // Fallback to location assets if no shelf match
  if (matchingShelves.length === 0 && data.location && config.locationAssets) {
    const matchingAsset = config.locationAssets.find(
      (asset) => asset.location === data.location
    );
    if (matchingAsset) {
      matchingShelves.push(matchingAsset);
    }
  }
}

      // Check for matches and highlight
      if (matchingShelves.length === 0) {
        setError("No Results can be found, please contact the Library at library@ln.edu.hk");
        // setError(`No matching shelves found for the search criteria.`);
        setIsLoading(false);
        return;
      }

      // Add highlights
      if (spaceRef.current && matchingShelves.length > 0) {
        setTimeout(() => {
          try {
            // Remove any existing layer
            try {
              spaceRef.current.removeDataLayer("bookshelves");
            } catch (removeError) {
              console.log("Remove layer (expected):", removeError.message);
            }

            // Add new highlights
            setTimeout(() => {
              try {
                // Layer 1: Highlight all shelves (no tooltips)
spaceRef.current.addDataLayer({
  id: "bookshelves-highlight",
  type: "furniture", 
  data: matchingShelves,
  tooltip: false, // No tooltips at all
  color: () => "#50b268",
});

// Layer 2: Tooltip only for first shelf
spaceRef.current.addDataLayer({
  id: "bookshelves-tooltip",
  type: "furniture",
  data: [matchingShelves[0]], // Only first shelf
  tooltip: (d) => {
    if (d.bookData) {
      let tooltipContent = `<span style="font-weight: 900;">Call Number:</span> ${callNumber}`;
      if (d.bookData.book_defn) {
        tooltipContent += ` | <span style="font-weight: 900;">Location:</span> ${d.bookData.book_defn}`;
      }
      return tooltipContent;
    }
    return d.name;
  },
  color: () => "#50b268",
  persistentTooltip: true,
});
                console.log(
                  "Successfully added data layer with",
                  matchingShelves.length,
                  "shelves"
                );
              } catch (addError) {
                console.log("Add layer error:", addError.message);
              }
            }, 100);

            // Set camera position
            if (callNumber && dataArray[0] && dataArray[0].book_shelf_number) {
              setCameraPosition(dataArray[0].book_shelf_number);
            } else if (data.location) {
              setCameraPosition("ServiceCounter");
            }
          } catch (e) {
            console.log("Layer operation error:", e.message);
          }
        }, 500);
      }
    } catch (err) {
      console.error("Error in search and highlight:", err);
      setError("No Results can be found, please contact the Library at library@ln.edu.hk");
      // setError("Error searching for books");
    } finally {
      setIsLoading(false);
    }
  };

  // Initialize everything
  const initialize = async () => {
    const locationCode = getQueryParameter("locationCode");
    const callNumber = getQueryParameter("callNumber");

    console.log("URL Parameters:", { locationCode, callNumber });

    if (!locationCode) {
      console.error("Missing locationCode parameter");
      setError("No Results can be found, please contact the Library at library@ln.edu.hk");
      // setError("Missing locationCode parameter");
      setIsLoading(false);
      return;
    }

    if (isInitializedRef.current) return;
    isInitializedRef.current = true;

    try {
      // STEP 1: Determine the correct floor BEFORE initializing viewer
      const correctFloor = await determineCorrectFloor(
        locationCode,
        callNumber
      );
      const config = floorConfigs[correctFloor];

      console.log(`Using floor: ${correctFloor}, spaceId: ${config.spaceId}`);

      if (!config) {
        console.error("Invalid floor configuration:", correctFloor);
        setError("No Results can be found, please contact the Library at library@ln.edu.hk");
        // setError("Invalid floor configuration");
        setIsLoading(false);
        return;
      }

      // Wait for libraries to load
      await new Promise((resolve) => {
        const checkLibraries = () => {
          if (window.smplr) {
            console.log("smplr library loaded");
            resolve();
          } else {
            setTimeout(checkLibraries, 100);
          }
        };
        checkLibraries();
      });

      // Give extra time for DOM to be ready
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Create container
      const containerElement = document.createElement("div");
      const containerId = `smplr-container-${Date.now()}`;
      containerElement.id = containerId;
      containerElement.style.width = "100%";
      containerElement.style.height = "100%";
      containerElement.style.backgroundColor = "#f0f0f0";
      containerElement.style.position = "absolute";
      containerElement.style.top = "0";
      containerElement.style.left = "0";

      if (containerRef.current) {
        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(containerElement);
        console.log("Container created with ID:", containerId);
      }

      // STEP 2: Initialize smplr space with CORRECT spaceId
      spaceRef.current = new window.smplr.Space({
        spaceId: config.spaceId, // This is now the correct floor's spaceId
        clientToken: CLIENT_ID,
        containerId: containerId,
      });

      console.log("Starting viewer with correct config:", {
        floor: correctFloor,
        spaceId: config.spaceId,
        containerId,
      });

      // Start viewer
      // Determine initial camera based on floor
      const initialCamera =
        correctFloor === "1f"
          ? {
              alpha: 1.566796326794897,
              beta: 0.17702645662417016,
              radius: 90.75737929330322,
              target: {
                x: 70.43136145449171,
                y: 1,
                z: -48.228182803491535,
              },
            }
          : correctFloor === "2f"
          ? {
              alpha: -1.5722224976673886,
              beta: 0.7099240223592373,
              radius: 65.566640313453746,
              target: { x: 31.2418383712391, y: 16, z: -53.20580854095632 },
            }
          : correctFloor === "3f"
          ? {
              alpha: -1.5721425958892115,
              beta: 0.7099240223592373,
              radius: 80.84028674223195,
              target: { x: 36.719494692293786, y: 10, z: -46.63437307052993 },
            }
          : correctFloor === "mf"
          ? {
              alpha: 1.5642931020318165,
              beta: 0.7099240223592373,
              radius: 71.228814129728086,
              target: {
                x: 69.04755001887268,
                y: 1,
                z: -44.24558015977757,
              },
            }
          : undefined;

      // Start viewer
      spaceRef.current.startViewer({
        preview: false,
        loadingMessage: "Loading...",
        disableCameraRotation: true,
        allowModeChange: true,
        ...(initialCamera && { cameraPlacement: initialCamera }),
        onReady: async () => {
          console.log("Viewer ready with correct floor");

          // Apply rotation-disabling CSS after viewer loads
          const style = document.createElement("style");
          style.textContent = `
  [id^="smplr-container"] canvas {
  }

  button[title="Hide annotations"] {
    display: none !important;
  }

  
  
  .smplr-zoom-controls,
  button[title*="zoom" i],
  button[title*="Zoom" i] {
    pointer-events: auto !important;
  }

  
`;
          document.head.appendChild(style);

          // STEP 3: Now search and highlight shelves
          setTimeout(() => {
            searchBooksAndHighlight(locationCode, callNumber, config);
          }, 300);
        },
        onError: (error) => {
          console.error("Viewer error:", error);
          // setError("Failed to load 3D viewer");
          setError("No Results can be found, please contact the Library at library@ln.edu.hk");
          setIsLoading(false);
        },
      });
    } catch (err) {
      console.error("Initialization error:", err);
      // setError("Failed to initialize viewer");
      setError("No Results can be found, please contact the Library at library@ln.edu.hk");
      setIsLoading(false);
    }
  };

  // Load libraries and initialize
  useEffect(() => {
    const loadLibraries = async () => {
      if (window.smplr) {
        initialize();
        return;
      }

      try {
        // Load CSS
        const cssLink = document.createElement("link");
        cssLink.href = "https://app.smplrspace.com/lib/smplr.css";
        cssLink.rel = "stylesheet";
        document.head.appendChild(cssLink);

        // Load JS
        const script = document.createElement("script");
        script.src = "https://app.smplrspace.com/lib/smplr.js";
        script.onload = () => {
          console.log("smplr.js loaded successfully");
          setTimeout(initialize, 100);
        };
        script.onerror = () => {
          // setError("Failed to load 3D viewer library");
          setError("No Results can be found, please contact the Library at library@ln.edu.hk");
          setIsLoading(false);
        };
        document.head.appendChild(script);
      } catch (err) {
        // setError("Library loading failed");
        setError("No Results can be found, please contact the Library at library@ln.edu.hk");
        setIsLoading(false);
      }
    };

    loadLibraries();
  }, []);

  // Check if we should render
  const locationCode = getQueryParameter("locationCode");
  const callNumber = getQueryParameter("callNumber");

  console.log("Render check - Parameters:", { locationCode, callNumber });

  if (!locationCode) {
    console.log("No locationCode parameter found, not rendering");
    return null;
  }

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <header className="bg-[#ffffff] custom-shadow h-12 sm:h-14 lg:h-20 xl:h-[100px] w-full flex items-center justify-between px-0 sm:px-0">
          <div className="flex items-center h-full">
            <img
              src="/library-logo-final_2024.png"
              alt="LNU Logo"
              className="h-4 sm:h-6 md:h-8 lg:h-12 xl:h-12 2xl:h-14 ml-1 sm:ml-6"
            />
          </div>
        </header>
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            color: "red",
            fontFamily: "Arial, sans-serif",
            height: "calc(100vh - 100px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          No Results can be found, please contact the Library at library@ln.edu.hk
        </div>
      </div>
    );
  }
  // Combined Legend Box Component
  const LegendBox = () => (
    <div
      style={{
        position: "absolute",
        bottom: "2px",
        left: "56px",
        background: "rgba(219, 218, 218, 0.492)",
        border: "1px solid #ddd",
        borderRadius: "6px",
        padding: "6px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        zIndex: 1001,
        fontSize: "12px",
        fontFamily: "Inter, sans-serif",
        fontWeight: 500,
        color: "#333",
        minWidth: "100px",
      }}
    >
      <div
        style={{
          padding: "2px",
          textAlign: "center",
          borderBottom: "1px solid #ccc",
          marginBottom: "2px",
        }}
      >
        Default View
      </div>
      <div
        style={{
          padding: "2px",
          textAlign: "center",
          borderBottom: "1px solid #ccc",
          marginBottom: "2px",
        }}
      >
        Zoom in
      </div>
      <div
        style={{
          padding: "2px",
          textAlign: "center",
          borderBottom: "1px solid #ccc",
          marginBottom: "2px",
        }}
      >
        Zoom Out
      </div>
      <div style={{ padding: "8px 4px 4px 4px", textAlign: "center" }}>
        Switch 2D/3D
      </div>
    </div>
  );

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >

<header className="bg-[#ffffff] custom-shadow h-12 sm:h-14 lg:h-20 xl:h-[100px] w-full flex items-center justify-between px-0 sm:px-0">
        {/* Left side - Hamburger and Logo */}
      <div className="flex items-center h-full">
     
        <img
          src="/library-logo-final_2024.png"
          alt="LNU Logo"
          className="h-4 sm:h-6 md:h-8 lg:h-12 xl:h-12 2xl:h-14 ml-1 sm:ml-6"
        />
      </div>
    </header>


    <div
  ref={containerRef}
  style={{
    width: "100%",
    height: "calc(100vh - 98px)",  
    backgroundColor: "#f0f0f0",
    position: "relative",
  }}
  // className="sm:h-[calc(100vh-56px)] lg:h-[calc(100vh-80px)] xl:h-[calc(100vh-100px)]"
/>

      <LegendBox />

      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            zIndex: 1001,
            opacity: "0%",
            backgroundColor: "rgba(255,255,255,0.9)",
            padding: "20px",
            borderRadius: "8px",
            fontFamily: "Arial, sans-serif",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #3498db",
              borderRadius: "50%",
              opacity: "0%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 10px",
            }}
          ></div>
          <p style={{ margin: 0, opacity: "0%", color: "#666" }}>
            Loading 3D floor map...
          </p>
        </div>
      )}

<style>
  {`
 .sc-bBXxYQ.dcmoTP {
      transform: translateY(-76px) translateX(-40px) !important;
    }
  `}
</style>
    </div>
  );
};

export default LibraryBookFinder;
